import { defined } from "@/shared/utils/makeDefined.ts";
import type { DailyTag } from "@/pages/human-resources/time-management/business/daily-tag/DailyTag.ts";
import { sortByKey } from "@/shared/utils/Arrays.ts";

export class DailyTagResolver {
  private readonly tagsById: Map<string, DailyTag>;

  constructor(dailyTags: DailyTag[]) {
    this.tagsById = new Map<string, DailyTag>(dailyTags.map((t) => [t.id, t]));
  }

  public getById(id: string): DailyTag {
    return defined(this.tagsById.get(id), `No daily tag found for id: ${id}`);
  }

  public listAll(): DailyTag[] {
    const tags = Array.from(this.tagsById.values());
    sortByKey(tags, (t) => t.label);
    return tags;
  }
}
